import {
  Stack,
  List,
  ListItemText,
  Typography,
  Divider,
  ListItem,
  styled
} from "@mui/material";
import React from "react";

const options = [
  { label: "Individual", value: "individual" },
  { label: "Event Organizer", value: "eventOrganizer" }
];

const CustomListItem = styled(ListItem, {
  shouldForwardProp: prop => prop !== "isSelected",
  name: "List"
})<{ isSelected?: boolean; theme?: any }>(({ isSelected, theme }) => ({
  background: isSelected
    ? theme.palette.common.primary
    : theme.palette.common.white,
  color: isSelected
    ? theme.palette.common.white
    : theme.palette.common.grey,
  paddingLeft: theme.spacing(5.5),
  marginBottom: theme.spacing(1.5),
  cursor: "pointer"
}));

export interface DashboardSideListInterface {
  handleClick: (value: string) => void;
  selectedItem: string;
}

const DashboardSideList = ({
  handleClick,
  selectedItem
}: DashboardSideListInterface) => {
  return (
    <Stack py={4}>
      <Stack px={5.5} spacing={2}>
        <Typography variant="h5" className="font-grey" fontWeight={400}>
          User Type
        </Typography>
        <Divider />
      </Stack>

      <Stack mt={3}>
        <List>
          {options.map((option, index) =>
            <CustomListItem
              key={index}
              isSelected={selectedItem === option.value}
              onClick={() => handleClick(option.value)}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="h5"
                    fontWeight={500}
                  >
                    {option.label}
                  </Typography>
                }
              />
            </CustomListItem>
          )}
        </List>
      </Stack>
    </Stack>
  );
};

export default DashboardSideList;
